const regionNames =
	typeof Intl !== "undefined" && Intl.DisplayNames
		? new Intl.DisplayNames(["en"], { type: "region" })
		: null;

/** Blank countries stay New Zealand, matching the account default. */
export const accountCountryCode = (organisation) => {
	const code = (organisation?.country || "NZ").toString().trim().toUpperCase();
	if (!code || code === "NZ" || code === "NZL" || code === "NEW ZEALAND") return "NZ";
	if (code === "AU" || code === "AUS" || code === "AUSTRALIA") return "AU";
	return code;
};

export const accountCountryLabel = (organisation) => {
	const code = accountCountryCode(organisation);
	if (code === "NZ") return "New Zealand";
	try {
		return regionNames?.of(code) || code;
	} catch (_error) {
		return code;
	}
};

export const isExportAccount = (organisation) => accountCountryCode(organisation) !== "NZ";

/**
 * Same labels as the Subscription Status column, and mutually exclusive
 * so the buckets add up to the accounts on screen.
 */
export const accountSubscriptionGroup = (organisation) => {
	if (organisation?.lifecycleStatus === "GracePeriod") return "paymentIssue";
	if (organisation?.lifecycleStatus === "Disabled") return "disabled";
	if (organisation?.subscriptionStatus === "active") return "active";
	if (organisation?.subscriptionStatus === "trialing") return "trial";
	// A cancelled Stripe subscription is a disabled account, same as lifecycle Disabled.
	if (organisation?.subscriptionStatus) return "disabled";
	return "none";
};

/** Accounts shown by the Active filter. Cancelled and disabled accounts are inactive. */
export const isActiveAccount = (organisation) =>
	Boolean(organisation?.status) && accountSubscriptionGroup(organisation) !== "disabled";

export const summariseAccounts = (organisations = []) => {
	const list = Array.isArray(organisations) ? organisations : [];
	const summary = {
		active: 0,
		trial: 0,
		paymentIssue: 0,
		disabled: 0,
		none: 0,
		nz: 0,
		export: 0,
	};

	list.forEach((organisation) => {
		summary[accountSubscriptionGroup(organisation)] += 1;
		summary[isExportAccount(organisation) ? "export" : "nz"] += 1;
	});

	return summary;
};

export const matchesAccountSummary = (organisation, filterKey) => {
	if (!filterKey) return true;
	if (filterKey === "export") return isExportAccount(organisation);
	if (filterKey === "nz") return !isExportAccount(organisation);
	return accountSubscriptionGroup(organisation) === filterKey;
};

export const filterAccountsBySummary = (organisations = [], filterKey) => {
	const list = Array.isArray(organisations) ? organisations : [];
	if (!filterKey) return list;
	return list.filter((organisation) => matchesAccountSummary(organisation, filterKey));
};
